import { mobileViewActions } from '../../services';

export const mobileViewReducer = ( state = {view:"mediaView"}, action ) =>{
    switch(action.type){
      case mobileViewActions.LISTVIEW:
        return {...state, ["view"]:"listView"};
      case mobileViewActions.MEDIAVIEW:
        return {...state, ["view"]:"mediaView"};
      default:
        return state;
    }
  }